"use client";

/**
 * `use_and_care_block` is resolved by `ProductDetailTemplate` into the
 * "View Use & Care Guide" affordance on the About the Product section — never
 * rendered as a section of its own. The template filters it out of
 * `remainingBlocks` before passing them to `ContentBlocksRenderer`, so this
 * no-op exists solely so the dispatcher map stays exhaustive over
 * `CatalogContentBlockType`.
 */
export function UseAndCare(): null {
	return null;
}
